import type { StateCreator } from "zustand";

export type SidebarLayoutState = "main" | "profile" | null;

export interface SidebarLayoutSlice {
  sidebarLayoutState: SidebarLayoutState;
  setSidebarLayoutState: (state: SidebarLayoutState) => void;
  resetSidebarLayoutState: () => void;
}

export const createSidebarLayoutSlice: StateCreator<SidebarLayoutSlice> = (set) => ({
  sidebarLayoutState: "main",
  setSidebarLayoutState: (state: SidebarLayoutState) => set({ sidebarLayoutState: state }),
  resetSidebarLayoutState: () => set({ sidebarLayoutState: "main" }),
});
